export const INITIAL_LOGIN_REQUEST = "INITIAL_LOGIN_REQUEST";
export const FINAL_LOGIN_REQUEST = "FINAL_LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_ERROR = "LOGOUT_ERROR";
export const UPDATE_NOTIFICATIONS = "UPDATE_NOTIFICATIONS";
export const UPDATE_FILTER = "UPDATE_FILTER";
export const CLEAR_STORE = "CLEAR_STORE";
export const CHANGE_ESTATES = "CHANGE_ESTATES";
export const UPDATE_USER_ESTATES = "UPDATE_USER_ESTATES";
export const APPEND_USER_ESTATE_ACCESS = "APPEND_USER_ESTATE_ACCESS";
export const UPDATE_DASHBOARD = "UPDATE_DASHBOARD";
export const UPDATE_DASHBOARD_FILTER = "UPDATE_DASHBOARD_FILTER";
export const INITIAL_LOGOUT_REQUEST = "INITIAL_LOGOUT_REQUEST";
export const FINAL_LOGOUT_REQUEST = "FINAL_LOGOUT_REQUEST";
export const UPDATE_ESTATES_PARENTS_ESTATES = "UPDATE_ESTATES_PARENTS_ESTATES";
export const CLEAR_SURVEY = "CLEAR_SURVEY";
export const UPDATE_USER = "UPDATE_USER";
export const CHANGE_SEASON = "CHANGE_SEASON";
